import * as actionTypes from "./actionTypes";
import { appLoading, appSuccess, appError } from "./appActions";
import { toastr } from "react-redux-toastr";
import { registerPs, registerCs, resettingPasswordEmail as registerResettingPasswordEmail, resetPassword, studentListApi, sendConfirmationMailApi } from "../../api/studentsApi";
import { logoutUser } from "./authActions";
import { resettingPasswordApi } from "../../api/authApi"
import { useSelector } from "react-redux";
import { trackEvent } from "../../utils/trackEvent";

export const studentListSuccess = (data) => ({
  type: actionTypes.STUDENT_LIST_SUCCESS,
  payload: data,
});

export const studentListFailed = (data) => ({
  type: actionTypes.STUDENT_LIST_FAILED,
  payload: data,
});

export const registerStudentPs = (payload) => (dispatch) => {
  //const { student, history } = payload;
  dispatch(appLoading());
  registerPs(payload)
    .then((response) => {
      const { data } = response;
      dispatch(appSuccess());
      const userData = data?.data || {};
      trackEvent('signup', {
        user_data: {
          email: userData.user?.email,
          phone_number: userData.phone_number,
          first_name: userData.user?.name,
          last_name: userData.user?.lastName,
          city: userData.address?.city,
          address: userData.address?.street,
          postal_code: userData.address?.postalCode,
          country: userData.address?.country
        },
        registration_type: 'ps' 
      });
      //dispatch(addSchoolSuccess(data));
      toastr.success("INFO", "Pour confirmer la création de votre compte, nous vous invitons à consulter vos emails et cliquer sur le lien de confirmation.");
      //history.push('/schools');
    })
    .catch((error) => {
      dispatch(appError());
      if (error.response.data) {
        toastr.error("Error", error.response.data.message);
        console.log("Error: ", error.response.data.message);
      } else {
        toastr.error("Error", "Une erreur est survenue lors de la connexion au serveur");
        console.log("Error: ", "error connected to server");
        dispatch(logoutUser());
      }
    });
};

export const registerStudentCs = (payload) => (dispatch) => {
  //const { student, history } = payload;
  dispatch(appLoading());
  registerCs(payload)
    .then((response) => {
      const { data } = response;
      dispatch(appSuccess());
      const userData = data?.data || {};
      trackEvent('signup', {
        user_data: {
          email: userData.user?.email,
          phone_number: userData.phone_number,
          first_name: userData.user?.name,
          last_name: userData.user?.lastName,
          city: userData.address?.city,
          address: userData.address?.street,
          postal_code: userData.address?.postalCode,
          country: userData.address?.country
        },
        registration_type: 'cs' 
      });
      //dispatch(addSchoolSuccess(data));
      toastr.success("INFO", "Pour confirmer la création de votre compte, nous vous invitons à consulter vos emails et cliquer sur le lien de confirmation.");
      //history.push('/schools');
    })
    .catch((error) => {
      dispatch(appError());
      const data = error?.response?.data;

      if (data) {
        let messages = [];

        if (data.errors && typeof data.errors === 'object') {
          Object.entries(data.errors).forEach(([field, errs]) => {
            errs.forEach((msg) => {
              messages.push(`${field} : ${msg}`);
            });
          });
        }
        
        if (messages.length > 0) {
          toastr.error("Erreurs dans le formulaire", messages.join("<br>")); // ou "\n" selon toastr
        } else if (data.message) {
          // Erreur métier renvoyée par le back sans détail de formulaire
          // (ex : "Il existe déjà un compte avec cet email.") — sans ce cas,
          // l'échec était silencieux et l'utilisateur ne voyait aucun message.
          toastr.error("Erreur", data.message);
        } else {
          toastr.error("Erreur", "Une erreur est survenue. Veuillez réessayer.");
        }

      } else {
        toastr.error("Erreur", "Une erreur est survenue. Veuillez réessayer.");
        console.log("Error: error connected to server");
        dispatch(logoutUser());
      }
    });
};

export const resettingPasswordEmail = (payload) => (dispatch) => {
  // const { student, history } = payload;
  dispatch(appLoading());

  registerResettingPasswordEmail(payload)
    .then((response) => {
      const { data } = response;
      dispatch(appSuccess());
      toastr.success("INFO", "Un email vous a été envoyé.");
    })
    .catch((error) => {
      dispatch(appError());
      if (error.response.data) {
        toastr.error("Error", error.response.data.message);
        console.log("Error: ", error.response.data.message);
      } else {
        toastr.error("Erreur", "Une erreur est survenue. Veuillez ré-essayer.");
        console.log("Error: ", "error connected to server");
        dispatch(logoutUser());
      }
    });
};

export const resettingPassword = (payload, history) => (dispatch) => {
   dispatch(appLoading());
   resettingPasswordApi(payload).then((response) => {
      const { data } = response;
      dispatch(appSuccess());
      toastr.success("INFO", "Mot de passe réinitialisé!");
      history.push('/login/classic');

    })
    .catch((error) => {
      dispatch(appError());
      if(error.response.data.message
          &&   error.response.data.errors.children.password.errors[0]){
         console.log('Error: ', error.response.data.message + ". "
             // iterar
             +  error.response.data.errors.children.password.errors[0]);
          toastr.error('ERROR', error.response.data.message + ". "
              // iterar
              +  error.response.data.errors.children.password.errors[0]);
        } else {
            console.log('Error: ', 'error connected to server');
            toastr.error('Error', 'Une erreur est survenue lors de la connexion au serveur');
            }
      // toastr.error('', error.message);
     //  history.push('/not-found');
    })
}

export const studentList = (payload, history) => (dispatch) => {
  dispatch(appLoading());
  studentListApi()
    .then((response) => {
      const { data } = response;
      dispatch(appSuccess());
      dispatch(studentListSuccess(data.data));
    })
    .catch((error) => {
      dispatch(studentListFailed(error));
      dispatch(appError());
      if (error && error.response && error.response.data) {
        console.log("Error: ", error.response.data.message);
      } else {
        console.log("Error: ", "error connected to server");
      }
      toastr.error("ERROR", error.message);
      dispatch(logoutUser());
    });
}

export const sendConfirmationMail = (data, history) => (dispatch) => {
  dispatch(appLoading());
  sendConfirmationMailApi(data)
    .then((response) => {
      dispatch(appSuccess());
      toastr.success("INFO", "Email Envoyé");
    })
    .catch((error) => {
      dispatch(appError());
      if (error && error.response && error.response.data) {
        console.log("Error: ", error.response.data.message);
      } else {
        console.log("Error: ", "error connected to server");
      }
      toastr.error("ERROR", error.message);
      // dispatch(logoutUser());
    });
}